import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { jobberAuthorize } from "services";

const JobberCallback = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const navigate = useNavigate();

    useEffect(() => {
        if (!code) {
            navigate("/error", { replace: true });
            return;
        }

        // Jobber appends where the user launched from as `post_oauth_redirect`; carry it
        // through the flow so Step 3's "Return to Jobber" button can send them back.
        const returnUrl = searchParams.get("post_oauth_redirect");
        if (returnUrl) {
            sessionStorage.setItem("jobber_return_url", returnUrl);
        }

        (async () => {
            try {
                const res = await jobberAuthorize(code);
                sessionStorage.setItem('state', res.state);
                navigate("/jobber-facebook-step1", { replace: true });
            } catch(e: any) {
                navigate("/error", { replace: true });
            }
        })();
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Spinner />
            <h1>Jobber authentication in progress</h1>
        </div>
    );
};

export default JobberCallback;
